import React from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import { AgronodLogo } from "@agronod/mui-components";

type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl";
type Responsive<T> = T | Partial<Record<Breakpoint, T>>;

interface BrandLogoProps {
  /** Rendered width; the height follows the wordmark's aspect ratio. */
  width?: Responsive<number | string>;
  /** Rendered height; the width follows the aspect ratio. Give one of width or height. */
  height?: Responsive<number | string>;
  sx?: SxProps<Theme>;
}

/**
 * The Agronod wordmark from the design system, sized for its slot.
 *
 * `AgronodLogo` is a fixed 97×30 SVG without props, so sizing happens through
 * CSS on the wrapper: the given dimension is applied to the SVG and the other
 * stays `auto`, which its viewBox resolves to the correct aspect ratio.
 */
const BrandLogo: React.FC<BrandLogoProps> = ({ width, height, sx }) => (
  <Box
    role="img"
    aria-label="Agronod"
    sx={[
      {
        display: "inline-flex",
        lineHeight: 0,
        "& svg": {
          display: "block",
          width: width ?? "auto",
          height: height ?? "auto",
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <AgronodLogo />
  </Box>
);

export default BrandLogo;
